import axios from "axios";

const API_BASE = process.env.REACT_APP_USER_SERVICE_URL;
const API = axios.create({
  baseURL: API_BASE,
});

export async function fetchBuyers({
  token,
  page = 0,
  size = 10,
  search = "",
} = {}) {
  try {
    if (!token) {
      throw new Error("Authentication token is missing");
    }

    const res = await API.get("admins/users", {
      params: { page, size, search },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    // Extract _embedded.adminUserResponseList safely
    const buyers = res.data._embedded?.adminUserResponseList || [];

    // Return frontend-friendly format
    return {
      buyers,
      page: res.data.page || { number: 0, totalPages: 0, size: size },
      links: res.data._links || {},
    };
  } catch (error) {
    console.error("Failed to fetch buyers:", error);
    throw error;
  }
}

export async function updateBuyerStatus(userId, status, token) {
  if (!token) {
    throw new Error("Authentication token is missing");
  }
  const res = await API.patch(
    `/admins/user/${userId}/status`,
    { status },
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return res.data;
}

export async function deleteUser(userId, token) {
  if (!token) {
    throw new Error("Authentication token is missing");
  }
  const res = await API.delete(`/admins/users/${userId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
}
